import * as React from "react"

const SettingsDetails = ({ children }: any) => <div className="w-full overflow-y-auto overflow-x-hidden h-screen-25 pr-10 pl-10 md:pr-20 md:pl-20">{children}</div>

export default SettingsDetails
